import styles from "./MypageInput.module.scss";
import { validateRequired, validateMaxlength } from "../../utils/validate";

const MypageNameTextField = ({
  type = "text",
  name,
  subname,
  label,
  subLabel = [],
  maxLength = null,
  setValue,
  register,
  validation = [{}, {}],
  errors,
  watch,
  required = false,
  placeholder = "",
  autocomplete = null,
  isStatic = false,
  readOnly = false,
  glue = "",
}) => {
  const returnText = () => {
    let value = "";
    const val_0 = watch(subname[0]);
    const val_1 = watch(subname[1]);
    if (isExistValue(val_0) && isExistValue(val_1)) {
      value = val_0 + glue + val_1;
    }
    setValue(name, value);
    return value.length > 0 ? value : <p>&emsp;</p>;
  };

  const isExistValue = (value) => {
    return typeof value !== "undefined" && value !== null && value.length > 0;
  };

  /**** バリデーションルール設定 ****/
  // 項目ごとのルール
  let txt_validation_0 = validation;
  let txt_validation_1 = validation;
  if (typeof maxLength === "object") {
    // 最大文字数が設定されていたら最大文字数バリデーションルール設定
    if (typeof maxLength[0] !== "undefined") {
      txt_validation_0 = {
        ...txt_validation_0,
        ...validateMaxlength(maxLength[0]),
      };
    }
    if (typeof maxLength[1] !== "undefined") {
      txt_validation_1 = {
        ...txt_validation_1,
        ...validateMaxlength(maxLength[1]),
      };
    }
  }
  if (required) {
    // 必須項目なら必須バリデーションルール設定
    txt_validation_0 = { ...txt_validation_0, ...validateRequired() };
    txt_validation_1 = { ...txt_validation_1, ...validateRequired() };
  }

  return (
    <div className={styles.mypageform__block}>
      <div className={`${styles.mypageform__ttl}`}>
        {label}
        <span className={styles.mypageform__ttl__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </div>
      <div
        className={`${styles.mypageform__multilabelfield} ${
          isStatic ? "d-none" : ""
        }`}
      >
        <div className={`${styles.mypageform__multilabel}`}>{subLabel[0]}</div>
        <div className={`${styles.mypageform__multilabel}`}>{subLabel[1]}</div>
      </div>
      <div>
        <div
          className={`${styles.mypageform__multifield} ${
            isStatic ? "d-none" : ""
          } ${errors[subname[0]] || errors[subname[1]] ? "is-invalid" : ""}`}
        >
          <input
            type={type ? type : "text"}
            name={subname[0]}
            className={`${styles.mypageform__multitxt} form-control ${
              errors[subname[0]] ? "is-invalid" : ""
            }`}
            // maxLength={maxLength}
            placeholder={placeholder}
            autoComplete={autocomplete}
            {...register(subname[0], txt_validation_0)}
            readOnly={readOnly}
          />
          <input
            type={type ? type : "text"}
            name={subname[1]}
            className={`${styles.mypageform__multitxt} form-control ${
              errors[subname[1]] ? "is-invalid" : ""
            }`}
            // maxLength={maxLength}
            placeholder={placeholder}
            autoComplete={autocomplete}
            {...register(subname[1], txt_validation_1)}
            readOnly={readOnly}
          />
        </div>
        {errors[subname[0]] || errors[subname[1]] ? (
          <p className={`invalid-feedback w-100 ${styles.mypageform__msg}`}>
            {typeof errors[subname[0]] !== "undefined"
              ? errors[subname[0]].message
              : typeof errors[subname[1]] !== "undefined"
              ? errors[subname[1]].message
              : ""}
          </p>
        ) : (
          <></>
        )}
      </div>
      {/* 確認画面表示用 */}
      {isStatic && (
        <div className={`${styles.mypageform__label} ws-pre-wrap ps-4`}>
          {returnText()}
          <div hidden>
            <input type="text" name={name} />
          </div>
        </div>
      )}
    </div>
  );
};

export default MypageNameTextField;
